import { Component, Input } from '@angular/core';

@Component({
  selector: 'ebo-accordion',
  templateUrl: './ebo-accordion.component.html',
  styleUrls: ['./ebo-accordion.component.scss']
})
export class EboAccordionComponent {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() style: 1;
  @Input() isExpanded = false;
  @Input() disabled = false;

  toggle(): void {
    if (!this.disabled) {
      this.isExpanded = !this.isExpanded;
    }
  }

}
